
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="https://public.readdy.ai/ai/video_res/7de18555-4f27-40fb-a558-4eded7318f0c.mp4" type="video/mp4" />
      </video>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="w-full">
          <div className="max-w-5xl mx-auto text-center">
            <div className="space-y-8">
              <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white leading-tight">
                中国普洱茶供应链
                <span className="block text-blue-500 mt-2">首选平台</span>
              </h1>
              
              <p className="text-base md:text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
                服务500+工厂 · 赋能2000+达人 · 年发货超千万单
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto my-12">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-500 mb-1">500+</div>
                  <div className="text-white text-xs md:text-sm">合作工厂</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-500 mb-1">2000+</div>
                  <div className="text-white text-xs md:text-sm">服务达人</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-500 mb-1">1000万+</div>
                  <div className="text-white text-xs md:text-sm">年发货单</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-500 mb-1">5万+㎡</div>
                  <div className="text-white text-xs md:text-sm">仓储面积</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <a href="/anchor-cooperation">
                  <Button variant="secondary" size="lg" className="text-sm md:text-lg px-8 py-4">
                    <i className="ri-live-line mr-2"></i>
                    我是主播/渠道，寻求货源
                  </Button>
                </a>
                <a href="/factory-cooperation">
                  <Button variant="outline" size="lg" className="text-sm md:text-lg px-8 py-4 bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-blue-600">
                    <i className="ri-building-line mr-2"></i>
                    我是工厂，寻求渠道
                  </Button>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#authority" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
